"use client";

import { useCallback, useEffect, useRef, useState } from "react";

const SCROLL_THRESHOLD = 80;
const SCROLL_UP_THRESHOLD = 10;

/**
 * Returns { shouldHide, onScroll } for hiding headers on scroll down.
 * Attach onScroll to the scroll container - avoids ref timing issues.
 */
export function useScrollHide(options?: {
  enabled?: boolean;
  threshold?: number;
}) {
  const { enabled = true, threshold = SCROLL_THRESHOLD } = options ?? {};
  const [shouldHide, setShouldHide] = useState(false);
  const lastScrollTop = useRef(0);

  const onScroll = useCallback(
    (e: React.UIEvent<HTMLElement>) => {
      if (!enabled) return;
      const el = e.currentTarget;
      const scrollTop = el.scrollTop;

      if (scrollTop <= threshold) {
        setShouldHide(false);
      } else if (scrollTop > lastScrollTop.current + SCROLL_UP_THRESHOLD) {
        setShouldHide(true);
      } else if (scrollTop < lastScrollTop.current - SCROLL_UP_THRESHOLD) {
        setShouldHide(false);
      }

      lastScrollTop.current = scrollTop;
    },
    [enabled, threshold],
  );

  useEffect(() => {
    if (!enabled) setShouldHide(false);
  }, [enabled]);

  return { shouldHide, onScroll };
}
